import { typography } from "@dillon/Utilities/styleguide/Typography";
import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";

const setPostStyles = () => {
    // Add some post styleguide customizations. These cannot be overridden by the style guid.
    setPostStyleGuideTheme({
        breakpoints: {
            //       xs,  sm,  md,  lg,   xl
            values: [240, 425, 768, 1024, 1200],
            maxWidths: [540, 1200, 1200, 1200, 1200],
        },
        typography: {
            fontFamilyImportUrl:"/staticContent/stylesheet.css",
            ...typography,
        },
    });
};

export default setPostStyles;
